<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="变更记录"
    width="1000px"
    :close-on-click-modal="false"
    @close="hide"
  >
    <div v-loading="loading" class="history-container">
      <el-timeline v-if="recordList && recordList.length>0">
        <el-timeline-item
          v-for="(item,index) in recordList"
          :key="index"
          timestamp=""
          placement="top"
          color="#059E84"
        >
          <div class="line-text">
            <div class="text">
              <span class="name">操作时间：</span>
              <span class="info">{{ $dateFormatter(item.actionTime)||'--' }}</span>
            </div>
            <div class="text">
              <span class="name">操作类型：</span>
              <span class="info">{{ item.actionText||'--' }}</span>
            </div>
            <div class="text">
              <span class="name">操作人：</span>
              <span class="info">{{ item.actionUser||'--' }}</span>
            </div>
          </div>
          <div class="card">
            <div class="name">
              变更内容
            </div>
            <div v-if="item.action === 'CREATE'||item.afterTransfer" class="card-context">
              <div class="basic">
                转仓路径
              </div>
              <div class="content">
                <div class="left">
                  <listDesc
                    :fields="CHANGE_TEXT"
                    :record-params="item.action === 'CREATE' ? (item.afterTransfer || {}) : (item.beforeTransfer || {})"
                  />
                </div>
                <div class="center more-height">
                  <i v-if="item.action !== 'CREATE'" class="el-icon-d-arrow-right" />
                </div>
                <div class="right">
                  <listDesc
                    v-if="item.action !== 'CREATE'"
                    :fields="CHANGE_TEXT"
                    :record-params="item.afterTransfer || {}"
                  />
                </div>
              </div>
            </div>
            <div class="card-context" style="margin-top: 12px">
              <!-- <div class="basic">
                转仓链路
              </div> -->
              <div class="content">
                <div class="left">
                  <el-table
                    :data="item.action === 'CREATE'?item.afterRuleList:item.beforeData"
                    border
                    style="width: 100%"
                  >
                    <el-table-column
                      v-for="t in tableFields"
                      :key="t.prop"
                      :prop="t.prop"
                      :label="t.label"
                    />
                  </el-table>
                </div>
                <div class="center more-height">
                  <i v-if="item.action !== 'CREATE'" class="el-icon-d-arrow-right" />
                </div>
                <div class="right">
                  <el-table
                    v-if="item.action !== 'CREATE'"
                    :data="item.afterData"
                    border
                    style="width: 100%"
                  >
                    <el-table-column
                      v-for="t in tableFields"
                      :key="t.prop"
                      :prop="t.prop"
                      :label="t.label"
                    />
                  </el-table>
                </div>
              </div>
            </div>
            <div class="card-context">
              <div class="basic">
                附加条件
              </div>
              <div class="content">
                <div class="left">
                  <listDesc
                    :fields="CONDITION_TEXT"
                    :record-params="item.action === 'CREATE' ? (item.afterTransfer || {}) : (item.beforeTransfer || {})"
                  />
                </div>
                <div class="center more-height">
                  <i v-if="item.action !== 'CREATE'" class="el-icon-d-arrow-right" />
                </div>
                <div class="right">
                  <listDesc
                    v-if="item.action !== 'CREATE'"
                    :fields="CONDITION_TEXT"
                    :record-params="item.afterTransfer || {}"
                  />
                </div>
              </div>
            </div>
          </div>
        </el-timeline-item>
      </el-timeline>
      <el-empty v-else description="暂无数据" />
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogVisible = false">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { warehouseHistoryList } from '@/api/configure/ownerRule';
import {
  CHANGE_TEXT,
  CONDITION_TEXT,
  changetableColumn,
  warehouseOptions,
} from '../constant';
import listDesc from './listDesc.vue';

export default {
  components: { listDesc },
  props: {
    goodsGroupOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showNumber: 3,
      CHANGE_TEXT,
      CONDITION_TEXT,
      tableFields: changetableColumn,
      dialogVisible: false,
      recordList: [],
      // addParams: {},
      loading: false,
    };
  },
  methods: {
    getLabel(list, name1, name2) {
      const lableList = [];
      list.forEach((item) => {
        if (name2) {
          lableList.push(item[name2] ? item[name2] : item[name1]);
        } else {
          lableList.push(item[name1] || '');
        }
      });
      return lableList.join(',');
    },
    async fetchData(row) {
      this.loading = true;
      this.recordList = [];
      try {
        const data = await warehouseHistoryList({ id: row.id });
        this.recordList = data.map((t) => ({
          ...t,
          actionText: t.action === 'CREATE' ? '新增' : '编辑',
          beforeData: t.beforeRuleList.map((m) => ({
            contractName: m.contractName,
            tenantName: m.tenantName,
          })),
          afterData: t.afterRuleList.map((m) => ({
            contractName: m.contractName,
            tenantName: m.tenantName,
          })),
          beforeTransfer: {
            ...(t.beforeTransfer || {}),
            typeText: warehouseOptions[t.beforeTransfer?.type],
            project: this.getLabel(t.beforeProjectList || [], 'projectName'),
            areas: this.getLabel(t.beforeAreaList || [], 'province', 'city'),
          },
          afterTransfer: {
            ...(t.afterTransfer || {}),
            typeText: warehouseOptions[t.afterTransfer?.type],
            project: this.getLabel(t.afterProjectList || [], 'projectName'),
            areas: this.getLabel(t.afterAreaList || [], 'province', 'city'),
          },
        }));
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    show(row) {
      this.dialogVisible = true;
      this.fetchData(row);
      // this.addParams = {
      //   ...row,
      //   areas: row.ext && row.ext.province ? row.ext.province + row.ext.city : '--',
      //   typeText: warehouseOptions[row.type],
      // };
    },
    hide() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog{
  .el-dialog__body{
    padding-bottom: 0;
  }
  .history-container {
    max-height: 70vh;
    overflow: auto;
    .el-timeline{
      padding:4px;
      box-sizing: border-box;
    }
    .el-timeline-item{
      padding-bottom:40px;
    }
    .el-timeline-item__tail{
      border-left: 2px solid #059E84;
    }
    .line-text{
      display: flex;
      position: relative;
      top:-12px;
      .text{
        margin-right: 32px;
        .name{
          color:#969799;
        }
        .info{
          color:#323233
        }
      }
    }
    .card{
      .name{
        color:#969799;
        margin-bottom:9px;
      }
      .el-table th{
        background: #F7F8FA!important;
      }
      .basic {
          font-weight: bold;
          font-size: 16px;
          padding:10px 0 10px 14px;
        }
      .content{
        display: flex;
        line-height:26px;
        .box{
          background: #F7F8FA;
          width:100%;
          padding:0 18px;
          box-sizing: border-box;
        }
      }
      .left,.right{
        flex:1;
      }
      .center{
        width:80px;
        text-align:center;
        display:flex;
        align-items:center;
        justify-content: center;
        font-size:20px;
      }
    }
  }
  .el-empty{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .el-empty__image{
      width:200px;
    }
  }
}
</style>
